import React from 'react';
import {twMerge} from '../../../common/twMerge';
import {MoreExpandListDetailProps} from './MoreExpandListDetailProps.interface';

const MoreExpandListDetail = React.memo(
  ({
    isActive,
    contents,
    className,
    useDangerouslySetInnerHTML = true,
    ...props
  }: MoreExpandListDetailProps) => {
    return (
      <dd
        {...(useDangerouslySetInnerHTML
          ? {
              dangerouslySetInnerHTML: {
                __html: contents,
              },
            }
          : {
              children: contents,
            })}
        className={twMerge(
          'm-0 break-words bg-theme-bg-surface-alt py-24pxr px-15pxr text-theme-solid-100',
          isActive ? 'block' : 'hidden',
          '*:text-[13px]! *:text-theme-solid-100! [&>a]:underline',
          className
        )}
        {...props}
      />
    );
  },
  areEqual
);

MoreExpandListDetail.displayName = 'MoreExpandListDetail';

function areEqual(
  prevProps: MoreExpandListDetailProps,
  nextProps: MoreExpandListDetailProps
) {
  return prevProps.isActive === nextProps.isActive;
}

export {MoreExpandListDetail};
